import styled from "styled-components";

export const EmptyBox = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`